import script from "./ExternProcessDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternProcessDetails.vue?vue&type=script&setup=true&lang=js"

import "./ExternProcessDetails.vue?vue&type=style&index=0&id=4eae52c3&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eae52c3"]])

export default __exports__